import { render, staticRenderFns } from "./addStudent.vue?vue&type=template&id=442335f3"
import script from "./addStudent.vue?vue&type=script&lang=js"
export * from "./addStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports